/* istanbul ignore file */

export class URLHyperLink {
    label = "";
    urlLink = "";
}
